import { BaseNumber, CheckedAddress, NormalizedNumber } from '@sparkdotfi/common-universal'
import { QueryKey, queryOptions } from '@tanstack/react-query'
import { Config } from 'wagmi'
import { readContract } from 'wagmi/actions'

import { spkStakingModuleAbi, spkStakingModuleAddress } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { Token } from '@/domain/types/Token'

export interface SpkSlashableBalanceQueryOptionsParams {
  address: CheckedAddress | undefined
  chainId: number
  wagmiConfig: Config
  spk: Token
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function spkSlashableBalanceQueryOptions({
  address,
  chainId,
  wagmiConfig,
  spk,
}: SpkSlashableBalanceQueryOptionsParams) {
  return queryOptions({
    queryKey: spkSlashableBalanceQueryKey({ address, chainId }),
    queryFn: () => spkSlashableBalanceQueryFunction({ address, chainId, wagmiConfig, spk }),
  })
}

export function spkSlashableBalanceQueryKey({
  address,
  chainId,
}: Pick<SpkSlashableBalanceQueryOptionsParams, 'address' | 'chainId'>): QueryKey {
  return ['spk-slashable-balance', address, chainId]
}

export async function spkSlashableBalanceQueryFunction({
  address,
  wagmiConfig,
  chainId,
  spk,
}: SpkSlashableBalanceQueryOptionsParams): Promise<NormalizedNumber> {
  if (!address) {
    return NormalizedNumber(0)
  }

  const result = await readContract(wagmiConfig, {
    address: getContractAddress(spkStakingModuleAddress, chainId),
    abi: spkStakingModuleAbi,
    functionName: 'slashableBalanceOf',
    args: [address],
    chainId,
  })

  return BaseNumber(result).toNormalizedUnit(spk.decimals)
}
